import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgProfileIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 12 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.6875 6.625C4.51953 6.625 3.45312 6.01562 2.86914 5C2.28516 4.00977 2.28516 2.76562 2.86914 1.75C3.45312 0.759766 4.51953 0.125 5.6875 0.125C6.83008 0.125 7.89648 0.759766 8.48047 1.75C9.06445 2.76562 9.06445 4.00977 8.48047 5C7.89648 6.01562 6.83008 6.625 5.6875 6.625ZM4.51953 7.84375H6.83008C9.34375 7.84375 11.375 9.875 11.375 12.3887C11.375 12.7949 11.0195 13.125 10.6133 13.125H0.736328C0.330078 13.125 0 12.7949 0 12.3887C0 9.875 2.00586 7.84375 4.51953 7.84375Z",
		fill: "#B6B6B6"
	})
});
export { SvgProfileIcon as ReactComponent };
